export default "__VITE_ASSET__5da31694__"